import { render, staticRenderFns } from "./RecoveredPassForm.vue?vue&type=template&id=55e14cd9"
import script from "./RecoveredPassForm.vue?vue&type=script&lang=js"
export * from "./RecoveredPassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports